import { AppRoute } from "app/app-layout/constants";
import { NavCategoryId } from "app/app-layout/models/nav/nav-category-ids.enum";
import { NavItemPrimary } from "app/app-layout/models/nav/nav-item-primary.model";
import { NavItemSecondary } from "app/app-layout/models/nav/nav-item-secondary.model";
import { AuthMatch } from "app/core/authentication/models/auth-match.enum";
import { AppScopes } from "app/core/authentication/models/scopes.enum";
import { FeatureCode } from "app/core/feature-control/models";

export class ReportsNavItem extends NavItemPrimary {
  constructor() {
    super({
      labelId: "$nav_primary_reports",
      route: AppRoute.reports,
      categoryId: NavCategoryId.REPORTS,
      categoryIcon: "ico-nav-reports.svg",
      menuItems: [
        new ReportsDashboardNavItem(),
        new AssessmentResultsNavItem(),
        new WorkloadNavItem(),
        new ActivityReportNavItem(),
        new EquipmentReportNavItem(),
        // new ExecutiveSummaryNavItem(),
        // new IndicatorsReportNavItem(),
        // new GapAssessmentNavItem(),
        // new RoiNavItem(),
      ],
    });
  }
}

export class ReportsDashboardNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: "$reports_nav_secondary_mgmt_overview",
      route: AppRoute.managementOverview,
      scopes: [AppScopes.DASH_BOARD, AppScopes.FULL_ACCESS],
      scopeMatch: AuthMatch.ALL,
      categoryId: NavCategoryId.REPORTS,
    });
  }
}

export class WorkloadNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: "$workload_page_title",
      route: AppRoute.workload,
      scopes: [AppScopes.WORKLOAD, AppScopes.FULL_ACCESS],
      scopeMatch: AuthMatch.ALL,
      categoryId: NavCategoryId.REPORTS,
    });
  }
}

export class ActivityReportNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: "$reports_nav_secondary_act_rprt",
      route: AppRoute.activityReport,
      scopes: [AppScopes.ACTIVITY_REPORT, AppScopes.FULL_ACCESS],
      scopeMatch: AuthMatch.ALL,
      categoryId: NavCategoryId.REPORTS,
    });
  }
}

export class AssessmentResultsNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: "$lng_adm_tit2",
      route: AppRoute.assessmentResults,
      scopes: [AppScopes.ASSESSMENT_RESULTS],
      categoryId: NavCategoryId.REPORTS,
    });
  }
}

export class EquipmentReportNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: "Equipment Report",
      route: AppRoute.equipmentReport,
      scopes: [AppScopes.FULL_ACCESS],
      categoryId: NavCategoryId.REPORTS,
      featureCode: FeatureCode.EQUIPMENT_REPORT,
    });
  }
}

// export class IndicatorsReportNavItem extends NavItemSecondary {
//   constructor() {
//     super({
//       labelId: 'Indicators Report',
//       // route: AppRoute.indicatorsReport, // Removed for prototype
//       route: AppRoute.noOp,
//       scopes: [
//         AppScopes.INDICATORS_REPORT,
//       ],
//       categoryId: NavCategoryId.REPORTS,
//     });
//   }
// }

// export class GapAssessmentNavItem extends NavItemSecondary {
//   constructor() {
//     super({
//       labelId: 'Gap Assessment',
//       route: AppRoute.gapAssessment,
//       scopes: [
//         AppScopes.INDICATORS_REPORT,
//       ],
//       categoryId: NavCategoryId.REPORTS,
//     });
//   }
// }

// export class RoiNavItem extends NavItemSecondary {
//   constructor() {
//     super({
//       labelId: 'Return on Investment',
//       route: AppRoute.returnOnInvestment,
//       scopes: [
//         AppScopes.ROI,
//       ],
//       categoryId: NavCategoryId.REPORTS,
//     });
//   }
// }
